/**
 * Form library layer
 *
 * Use Field here to avoid possible loop issue of validation
 */

import { forwardRef, Component } from 'react'
import Field from './FieldCreator'
import FormValueSelector from './FormValueSelector'
import FormMetaSelector from './FormMetaSelector'
import FormDecorator from './FormDecorator'

export const REDUX_FORM_STATE_KEY = 'reduxFormState'

export {
  Fields,
  FieldArray,
  FormSection,
  getFormValues,
  getFormNames,
  getFormMeta,
  getFormSyncErrors,
  reducer,
  formValueSelector
} from 'redux-form'

// hoc component 無法直接 set ref，ref 會直接存到 hoc 本身
// 需要透過 forwardRef 做一層轉換外部才能取得 component 的 ref
// https://reactjs.org/docs/forwarding-refs.html#forwarding-refs-in-higher-order-components
export const formDecorator = config => FormComponent => {
  class ComponentWithRef extends Component {
    render () {
      const { forwardedRef, ...restProps } = this.props
      return (
        <FormComponent
          {...restProps}
          ref={forwardedRef}
        />
      )
    }
  }

  const RFComponent = FormDecorator(config)(ComponentWithRef)

  return forwardRef((props, ref) => {
    return (
      <RFComponent
        {...props}
        forwardedRef={ref}
      />
    )
  })
}

export { Field, FormValueSelector, FormMetaSelector }
